import React from 'react';

// Shared "contact us on Facebook" call-to-action band.
// Used on the products listing and product detail pages so both stay consistent.
function FacebookCTA({
  heading,
  message,
  buttonLabel = 'Contact Us on Facebook',
  note = 'We typically respond within 24 hours',
}) {
  return (
    <section className="py-16 bg-gradient-to-r from-[#FED700] to-[#F4900C] relative overflow-hidden">
      {/* Decorative circles */}
      <div className="absolute -top-16 -left-16 w-64 h-64 bg-white/10 rounded-full"></div>
      <div className="absolute -bottom-20 -right-10 w-80 h-80 bg-white/10 rounded-full"></div>

      <div className="container-custom relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {heading}
          </h2>
          <p className="text-xl text-gray-800 mb-8">
            {message}
          </p>

          <a
            href="https://www.facebook.com/profile.php?id=61563842891479"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white text-gray-900 hover:bg-gray-50 font-bold py-4 px-8 rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 text-lg transform hover:-translate-y-0.5"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
            {buttonLabel}
          </a>

          <p className="text-sm text-gray-800 mt-6">
            {note}
          </p>
        </div>
      </div>
    </section>
  );
}

export default FacebookCTA;
